import {
  GhostButton,
  PrimaryButton,
  SecondaryTopNav,
} from "@certn/cascadia-react";
import { t } from "i18next";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { WorkdayIntegrationContext } from "../WorkdayIntegrationContext";

interface Props {
  onComplete?: () => void;
  isDisabled?: boolean;
  submitting?: boolean;
}

export function WorkdayIntegrationStepHeader({
  onComplete,
  isDisabled,
  submitting,
}: Props) {
  const navigate = useNavigate();
  const { goToPrevStep, currentStep } = useContext(WorkdayIntegrationContext);

  const cancel = () => {
    navigate("/settings/ats-integrations");
  };

  const steps = [
    { buttonLabel: t("Connect account") },
    { buttonLabel: t("Authenticate account") },
    { buttonLabel: t("Complete setup") },
  ];

  return (
    <SecondaryTopNav
      testID="workday-integration-setup-top-nav"
      leftIcon={currentStep === 0 ? "close" : "arrow_back"}
      onleftIconOnPress={currentStep === 0 ? cancel : goToPrevStep}
    >
      {currentStep > 0 && (
        <GhostButton
          onPress={cancel}
          testID="workday-integration-setup-top-nav-cancel-button"
        >
          {t("Cancel")}
        </GhostButton>
      )}
      <PrimaryButton
        onPress={onComplete}
        isDisabled={isDisabled}
        isLoading={submitting}
        testID="workday-integration-setup-top-nav-next-step-button"
      >
        {steps[currentStep].buttonLabel}
      </PrimaryButton>
    </SecondaryTopNav>
  );
}
